
<form class="formwidth"  #myForm="ngForm">
    <section *ngIf="errormessage">
        <div class="container" style="margin-top: 20px;">
            <div class="row">
                <p class="h4 text-danger" style="margin-left: 245px;">{{errormessage}}</p>
            </div>
        </div>
        </section>

    <section *ngIf="!errormessage">
        <mat-card appearance="outlined" style="width: 1365px;">
            <div  style="border-color: black;">
                <h3 style="font-weight: 500;">Vulnerability Details</h3>
                <table>                
                    <tr>                                                                
                        <td>
                            <label style="padding-right: 10px;font-weight: bold;">Date Raised</label>
                            <mat-form-field appearance="outline">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="myDatepicker" id="dtDateRaised" [(ngModel)]="objVulclass.DateRaised" name="DateRaised" required>
                                <mat-datepicker-toggle [for]="myDatepicker" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #myDatepicker></mat-datepicker>
                            </mat-form-field>
                            <!-- <mat-error *ngIf="DateRaised.invalid && DateRaised.touched">This field is required</mat-error> -->
                        </td> 
    
                        <td>
                            <label style="margin-left: 43px;padding-right: 10px;font-weight: bold;">In Scope (IMS/AMS)</label>
                            <mat-form-field appearance="outline">
                                <mat-label>Select</mat-label>
                                <mat-select id="selOrg" #org="ngModel" [(ngModel)]="objVulclass.Org" name="Org" required>
                                    <mat-option *ngFor="let lang of DDdata"  
                                    value={{lang.DDL}}>  
                                    {{lang.Value}}</mat-option>                                    
                                </mat-select>
                                <mat-error *ngIf="org.hasError('required')">This field is required</mat-error>  
                            </mat-form-field>
                        </td>                                            
                        
                        <td>
                            <label style="margin-left: 73px;padding-right: 10px;font-weight: bold;">CVE</label>
                            <mat-form-field appearance="outline">
                                <mat-label>CVE</mat-label>
                                <input matInput id="iCVE" #cve="ngModel" [(ngModel)]="objVulclass.CVE" (change)="checkValidCVE(objVulclass.CVE,objVulclass.VRef)" name="CVE" required>
                                <mat-error *ngIf="cve.invalid && cve.touched">This field is required</mat-error>              
                            </mat-form-field>
                        </td>
    
                        <td >
                            <label style="margin-left: 73px;padding-right: 10px;font-weight: bold;">Vref</label>
                            <mat-form-field appearance="outline" >
                                <!-- <mat-label>Input</mat-label> -->
                                <input style="background-color:#e9ecef" matInput id="iVref" [(ngModel)]="objVulclass.VRef" name="Vref" disabled="true" >
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
    
                <table>
                    <tr>
                        <td>
                            <label style="padding-right: 10px;;font-weight: bold;">Title</label>                   
                            <mat-form-field appearance="outline" style="width: 1293px;">
                                <!-- <mat-label>Input</mat-label> -->
                                <input matInput style="width: 750px;" id="iTitle" [(ngModel)]="objVulclass.Title" (change)="checkValidTitle(objVulclass.Title,objVulclass.VRef)" name="Title" required>
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td>
                            <label style="font-weight: bold;">Description</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <mat-form-field appearance="outline" style="width: 1335px;">
                                <!-- <mat-label>Textarea</mat-label> -->
                                <textarea matInput rows="3" id="iDesc" [(ngModel)]="objVulclass.Description" name="Desc" required></textarea>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label style="font-weight: bold;">Corrective Action</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <mat-form-field appearance="outline" style="width: 1335px;">
                                <!-- <mat-label>Textarea</mat-label> -->
                                <!-- <textarea matInput rows="3" id="iCorAction" [(ngModel)]="objVulclass.CorrectiveAction" name="CorrectiveAction" (input)="iCorAction.value.length > 8 && URLReplacer(objVulclass.CorrectiveAction)" #iCorAction required></textarea> -->
                                <textarea matInput rows="3" id="iCorAction" [(ngModel)]="objVulclass.CorrectiveAction" name="CorrectiveAction" required></textarea>
                                <!-- <input matInput style="width: 750px;" id="iCorAction1" [(ngModel)]="objVulclass.CorrectiveAction" name="CorrectiveAction1" (blur)="iCorAction1.value.length > 8 && URLReplacer(objVulclass.CorrectiveAction)" #iCorAction1 required> -->
                            </mat-form-field>
                            <!-- <div id="box">
                                <p contenteditable="true" id="pID"><a href="URL" title="Description">dsds</a></p>
                                </div> -->
                        </td>
                    </tr>
                    <!-- <tr>
                        <td>
                            <mat-form-field appearance="outline" style="width: 1335px;">
                                <input matInput type="url"  placeholder="Large Icon" name="largeicon" #largeicon="ngModel"
                                         [(ngModel)]="objVulclass.CorrectiveAction" href="#" (click)="OpenPopUpPage(objVulclass.CorrectiveAction)" class='linkPtr'
                                         required>
                              </mat-form-field>
                              
                              <div *ngIf="largeicon.errors && (largeicon.dirty || largeicon.touched)" class="alert alert-danger">
                                <div [hidden]="!largeicon.errors.required">URL is required!</div>
                                <div [hidden]="!largeicon.errors.pattern">Must be a valid URL!</div>
                              </div>
                        </td>
                    </tr> -->
                </table>
                <table>
                    <tr>
                        <td>
                            <form [formGroup]="productForm" >      
                                <table  formArrayName="quantities">
                                  <tr>
                                    <label style="font-weight: bold;">URLS - please add one URL per row, use + to add more rows</label>     
                                  </tr>
                                  <tr *ngFor="let quantity of quantities().controls; let i=index" [formGroupName]="i">
                                    <td>
                                        <!-- <mat-form-field appearance="outline" style="width: 1335px;">
                                          <mat-label>Textarea</mat-label> -->
                                          <!-- <input matInput style="width: 750px;" id="iDesc" [(ngModel)]="objAssclass.Question" name="Desc"> -->
                                          <!-- <textarea matInput rows="3" id="Desc{{i}}" class="form-control" formControlName="url"></textarea>
                                      </mat-form-field> -->

                                      <mat-form-field appearance="outline" style="width: 1000px;">
                                        <input matInput type="url"  class='linkPtr' autocomplete="off"
                                                 formControlName="dataurl" style="color: blue;"  (click)="OpenPopUpPage(i)"
                                                 required>
                                                 <!-- (click)="OpenPopUpPage(objVulclass.CorrectiveAction)" class='linkPtr' href="#" id="urlData{{i}}" -->
                                      </mat-form-field>
                                      <!-- <div *ngIf="!URLReplacer(i)" class="alert alert-danger">
                                        <div >Must be a valid URL!</div> 
                                      </div> -->
                                      <!-- <div *ngIf="dataurl.errors && (dataurl.dirty || dataurl.touched)" class="alert alert-danger">
                                        <div [hidden]="!dataurl.errors.required">URL is required!</div>
                                        <div [hidden]="!dataurl.errors.pattern">Must be a valid URL!</div> 
                                      </div> -->

                                    </td>       
                                    <td>
                                        <img src="assets/Minus Sign.svg" style="width:20px" id="AssessMinusbutton{{i}}" *ngIf="i > 0" (click)="removeQuantity(i)"/>
                                    </td>
                                  </tr>
                                  <tr>
                                    <img src="assets/Plus Sign.svg" style="width:20px" id="Assessplusbutton" (click)="addQuantity()"/>
                                </tr>
                                </table>  
                                
                              </form>
                        </td>
                    </tr>
                </table>
                <div align="center">               
                                <button (click)="onSubmit()" class="buttonnewvul">Save</button>  
                                <button (click)="Cancel()" class="buttonnewvul">Cancel</button>                      
                                <!-- <button (click)="onPublish()" class="buttonnewvul" style="margin-left: 10px;">Publish</button>                         -->
                </div>
            </div>
        </mat-card>
    </section>

</form>